// Feature flag to determine if user should have option to upload translations to CMS
export function featureFlagIsUploadAllowed() {
    try {
      return process.env.IS_UPLOAD_ALLOWED === "true";
    } catch (e) {
      console.error("Error finding IS_UPLOAD_ALLOWED token", e.message);
    }
  }
